import { Sort } from '@angular/material/sort';
import { ModuleUser } from '../../module-user/models/module-user.model';

export class SetMyRunningModules {
    static readonly type = '[MyRunningModules] SetMyRunningModules';

    constructor(public payload: ModuleUser[]) {}
}

export class UnsetMyRunningModules {
    static readonly type = '[MyRunningModules] UnsetMyRunningModules';
}

export class AddMyRunningModules {
    static readonly type = '[MyRunningModules] AddMyRunningModules';

    constructor(public payload: ModuleUser[]) {}
}

export class FetchMyRunningModule {
    static readonly type = '[MyRunningModules] FetchMyRunningModule';

    constructor(public payload: string) {}
}

export class FetchMyRunningModules {
    static readonly type = '[MyRunningModules] FetchMyRunningModules';

    constructor(
        public payload?: {
            category: string;
            search?: string;
            sortBy?: string;
            sortOrder?: string;
            pageSize?: number;
            pageNumber?: number;
            isRunning?: boolean;
            participantId?: string;
            tag?: number[];
        }
    ) {}
}

export class FetchMyRunningModulesSuccess {
    static readonly type = '[MyRunningModules] FetchMyRunningModulesSuccess';
}

export class FetchMyRunningModulesFailure {
    static readonly type = '[MyRunningModules] FetchMyRunningModulesFailure';
}

export class ToggleSelectedModule {
    static readonly type = '[MyRunningModules] ToggleSelectedModule';

    constructor(public payload: string) {}
}

export class SelectFilteredModules {
    static readonly type = '[MyRunningModules] SelectFilteredModules';
}

export class DeselectSelectedModules {
    static readonly type = '[MyRunningModules] DeselectSelectedModules';
}

export class SearchMyRunningModules {
    static readonly type = '[MyRunningModules] SearchMyRunningModules';

    constructor(public payload: string) {}
}

export class SortMyRunningModules {
    static readonly type = '[MyRunningModules] SetMyRunningModulesSort';

    constructor(public payload: Sort) {}
}
